import classNames from 'classnames'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import {
  BANNER_MODE_ICONS,
  UI2BannerProps,
  UI2_BANNER_DEFAULT_PROPS,
} from 'shared-libs/components/ui2/display/ui2-banner/ui2-banner-props'
import { translateString } from 'shared-libs/helpers/utils'

import { UI2Icon } from 'browser/components/ui2/display/ui2-icon/ui2-icon'
import './_ui2-banner.scss'

export const UI2Banner: React.FC<UI2BannerProps> = (props) => {
  const resolvedProps = { ...UI2_BANNER_DEFAULT_PROPS, ...props }
  const {
    text,
    markdownText,
    mode = 'neutral',
    title,
    icon,
    children,
    translationTable,
    frames,
  } = resolvedProps
  const iconName = icon ?? BANNER_MODE_ICONS[mode]
  const containerClass = classNames('ui2-banner', `ui2-banner--${mode}`)
  const resolvedTable = Object.assign({}, frames?.getContext('translationTable'), translationTable)
  const translatedTitle = title ? translateString(title, resolvedTable) ?? title : undefined
  const translatedMarkdown = markdownText
    ? translateString(markdownText, resolvedTable) ?? markdownText
    : undefined
  const translatedText = text ? translateString(text, resolvedTable) ?? text : undefined
  const body = translatedMarkdown ?? translatedText

  return (
    <div className={containerClass}>
      <div className="ui2-banner__header">
        <UI2Icon name={iconName} size={16} />
        {translatedTitle && <span className="ui2-banner__title">{translatedTitle}</span>}
      </div>
      {body && (
        <div className="ui2-banner__body">
          {translatedMarkdown ? <ReactMarkdown>{body}</ReactMarkdown> : body}
        </div>
      )}
      {children && <div className="ui2-banner__actions">{children}</div>}
    </div>
  )
}
